import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import SupportNavigation from '../components/support/SupportNavigation';
import ReportForm from '../components/support/ReportForm';
import MyReports from '../components/support/MyReports';
import SupportFAQ from '../components/support/SupportFAQ';
import './SupportPage.css';

const SupportPage = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('report');
  const [authState, setAuthState] = useState({
    isLoggedIn: false,
    loading: true
  });
  
  // Use direct localStorage check instead of the context
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      console.log("SupportPage - Token check:", !!token);
      
      if (!token) {
        setAuthState({
          isLoggedIn: false,
          loading: false
        });
        return;
      }
      
      setAuthState({
        isLoggedIn: true,
        loading: false
      });
    };
    
    checkAuth();
  }, []);
  
  // If still loading, show spinner
  if (authState.loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p className="loading-text">Loading...</p>
      </div>
    );
  }
  
  // Direct check for authentication
  if (!authState.isLoggedIn) {
    console.log("SupportPage - Not logged in, redirecting to login page");
    return <Navigate to="/login" state={{ from: '/support' }} />;
  }
  
  console.log("SupportPage - Logged in, showing support page");

  const renderContent = () => {
    switch (activeSection) {
      case 'report':
        return <ReportForm />;
      case 'my-reports':
        return <MyReports />;
      case 'faq':
        return <SupportFAQ />;
      default:
        return <ReportForm />;
    }
  };

  return (
    <main className="support-page">
      {/* New Title Section */}
      <div className="support-page-title-container">
        <h1 className="support-page-title">Support Center</h1>
        <p className="support-page-subtitle">
          We're here to help! Submit reports, track issues, and find answers to common questions.
        </p>
      </div>

      <div className="support-container">
        <SupportNavigation 
          activeSection={activeSection} 
          setActiveSection={setActiveSection} 
        />
        
        <div className="support-content">
          {renderContent()}
        </div>
      </div>
    </main>
  );
};

export default SupportPage;